import { render, staticRenderFns } from "./applicationSalonDetail.vue?vue&type=template&id=2fde4f18&scoped=true&"
import script from "./applicationSalonDetail.vue?vue&type=script&lang=js&"
export * from "./applicationSalonDetail.vue?vue&type=script&lang=js&"
import style0 from "./applicationSalonDetail.vue?vue&type=style&index=0&id=2fde4f18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fde4f18",
  null
  
)

export default component.exports